import React from "react";
import Back from '../../../../main/back';

const PageStateMessage = ({
	title,
	children
}) => {
	return (
		<div id="main-body" className="container">
			<div className="mt-5">
				<Back />
			</div>

			<div className="text-center mt-5">
				<h3>{title}</h3>
				{children}
			</div>
		</div>
	);
};

export default PageStateMessage;